import { Nullable } from 'cng-common/models/utils'
import { ISobAnalyticsReportJoined } from 'partner360/models/report/sobAnalyticsReports/ISobAnalyticsReportJoined'

import { getSobQField } from './getSobQField'
import { getSumOfNumbers } from './getSumOfNumbers'

interface IGetPlainSobParams {
  data: ISobAnalyticsReportJoined[]
  quarters: number[]
  isFuture?: boolean
  // SobExpExitQ{q}; takes precedence over isFuture
  isExpectedExit?: boolean
}

export const getPlainAverageSob = ({
  data,
  quarters,
  isFuture,
  isExpectedExit,
}: IGetPlainSobParams) => {
  const sobField = isExpectedExit ? 'ExpExit' : isFuture ? 'Plan' : 'Actual'

  const fields = quarters.map((quarter) => getSobQField({ field: sobField, quarter }))

  const sobValues = data
    .flatMap((reportData) => {
      const allSob = fields.map<Nullable<number>>((sobField) => {
        const sob = ((reportData as any)[sobField] ?? null) as Nullable<number>

        const hasPositiveSob = !!sob && sob > 0
        if (hasPositiveSob) {
          return sob
        }

        return null
      })
      return allSob
    })
    .filter((it) => it !== null)

  const sumOfSobs = getSumOfNumbers(sobValues)
  return sumOfSobs ? sumOfSobs / sobValues.length : null
}
